import { RootState } from 'app/store';

export const selectActiveToasts = (state: RootState) =>
  state.toastContainer.activeToasts;
